import { TFunction } from 'react-i18next'
import { CancellationPenaltyType, CancellationPolicyType, NoShowType, GuaranteeType } from 'src/api/api.generated'

export function displayPaymentType(t: TFunction<'translation', undefined>, type: GuaranteeType): string {
  const key = `commons.payment_type.${type.toLowerCase()}`
  return t(key as any)
}

export function displayCancellationPolicyType(t: TFunction<'translation', undefined>, type: CancellationPolicyType): string {
  const key = `commons.cancellation_policy_type.${type.toLowerCase()}`
  return t(key as any)
}

export function displayCancellationPenaltyType(t: TFunction<'translation', undefined>, type: CancellationPenaltyType): string {
  const key = `commons.cancellation_penalty_type.${type.toLowerCase()}`
  return t(key as any)
}

export function displayNoShowType(t: TFunction<'translation', undefined>, type: NoShowType): string {
  const key = `commons.no_show_type.${type.toLowerCase()}`
  return t(key as any)
}
